import script from "./DashboardGraph.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardGraph.vue?vue&type=script&setup=true&lang=js"

import "./DashboardGraph.vue?vue&type=style&index=0&id=4a7f57a2&lang=css"

const __exports__ = script;

export default __exports__